import {Injectable} from '@angular/core';
import {EagerInitialiser} from '@atlas-angular/cdk/init';

/**
 * @deprecated Use from @atlas-angular/cdk/init
 */
@Injectable({providedIn: 'root'})
export class DeprecatedEagerInitialiser extends EagerInitialiser {}
